<script>

export default {
  name: "ModalView",
  props: ['entity', 'isCarousel'],
  data() {
    return {
      imageLoaded: false,
    }
  },
  watch: {
    entity() {
      this.imageLoaded = false;
    }
  },
  methods: {
    close(e) {
      if (e.target.id === 'bgModal') {
        this.$emit('close');
      }
    },
  },
}
</script>

<template>
  <div class="w-full absolute top-0 left-0 h-full flex bg-black bg-opacity-60 overflow-hidden z-[12]">
    <div @click="close" id="bgModal" class="fixed inset-0 items-center justify-center flex">
      <template v-if="!entity.isVideo">
        <div id="bodyModal" class="bg-white xl:max-w-[960px] mx-8 md:mx-20 rounded-md h-auto relative">
          <button v-if="imageLoaded" type="button" @click="$emit('close')"
                  class="absolute z-[10] -top-4 -right-4 bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-0 focus:ring-indigo-0">
            <span class="sr-only">Close menu</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
          <div class="w-full h-full overflow-hidden">
            <div v-if="!imageLoaded" class="flex flex-col justify-center w-full min-h-[20vh] p-8 m-0">
              <span class="font-medium text-2xl">Loading Image...</span>
            </div>
            <img v-show="imageLoaded" class="transition-transform duration-700 ease-in-out transform w-full h-full max-h-[85vh]" @load="imageLoaded = true" :src="entity.src" alt=""/>
          </div>
          <template v-if="isCarousel">
            <button
              @click="$emit('prevCallback')"
              class="absolute left-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <button
              @click="$emit('nextCallback')"
              class="absolute right-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>

          </template>
        </div>
      </template>

      <template v-else>
        <template v-if="entity.isVimeo">
<!--          <div id="bodyModal" class="relative w-[80%] h-full container relative">-->
          <div id="bodyModal" class="relative w-full mx-8 md:mx-20 rounded-md h-[30vh] sm:h-[40vh] lg:h-[70vh] relative">
            <iframe
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              class="absolute top-0 left-0 w-full h-full"
              :src="entity.embed_url ? entity.embed_url : entity.video"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            >
            </iframe>
            <template v-if="isCarousel">
              <button
                @click="$emit('prevCallback')"
                class="absolute left-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
              >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
              </button>
              <button
                @click="$emit('nextCallback')"
                class="absolute right-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
              >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </template>
          </div>
        </template>
        <template v-else-if="entity.isCustomVideo">
          <div id="bodyModal" class="relative w-full mx-8 md:mx-20 rounded-md h-[30vh] sm:h-[40vh] lg:h-[70vh] relative flex items-center justify-center">
            <video autoplay preload="auto" controls
                   class="w-full h-full object-contain bg-black"
                   :src="entity.video">
               <source :src="entity.video"/>
            </video>

            <button type="button" @click="$emit('close')"
                    class="absolute z-[10] -top-4 -right-4 bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-0 focus:ring-indigo-0">
              <span class="sr-only">Close menu</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" class="h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>

        </template>
        <template v-else>
          <div id="bodyModal" class="relative w-full mx-8 md:mx-20 rounded-md h-[30vh] sm:h-[40vh] lg:h-[70vh] relative">
            <!--            <button type="button" @click="$emit('close')" class="absolute z-[9999999999] -top-4 -right-4 bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-0 focus:ring-indigo-0">-->
            <!--              <span class="sr-only">Close menu</span>-->
            <!--              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
            <!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />-->
            <!--              </svg>-->
            <!--            </button>-->
            <iframe
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              class="absolute top-0 left-0 w-full h-full"
              :src="entity.embed_url ? entity.embed_url : entity.video"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
            <template v-if="isCarousel">
              <button
                @click="$emit('prevCallback')"
                class="absolute left-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
              >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
              </button>
              <button
                @click="$emit('nextCallback')"
                class="absolute right-[-20px] top-[45%] z-10 bg-we-yellow text-white p-2 rounded-full"
              >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </template>
          </div>
        </template>

      </template>
    </div>
  </div>
</template>

<style>
.vcontainer {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

iframe, object, embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/Components/new/ModalView.vue